module.exports = __webpack_public_path__ + "9779d9a1/img/file-icon.c085e21e.svg";